import { z } from "zod";

export const DTOColorTokenInlineData = z.object({
  value: z.string().regex(/^#[a-f0-9]{6,8}$/),
});

export type DTOColorTokenInlineData = z.infer<typeof DTOColorTokenInlineData>;
